import { useEffect, useState } from 'react';
import { History } from '@/types/schemas/history.type';
import { QUERY_KEYS } from '@/constants/query-keys';
import { useAuth } from '@/contexts/auth-context';
import api from '@/lib/api';

/**
 * Hook for managing History data
 */
export const useHistory = (uuid: string) => {
  const [history, setHistory] = useState<History>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { entity } = useAuth();

  const fetchHistory = async () => {
    if (!entity?.slug) return;

    setIsLoading(true);
    try {
      const response = await api.get<History>(`/entities/${entity.slug}/erp/${QUERY_KEYS.HISTORY}/${uuid}/`);
      setHistory(response.data);
    } catch (error) {
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity?.slug]);

  return {
    history,
    isLoading
  };
};
